import { useTranslation as useI18nTranslation } from 'react-i18next';
import { apiService } from '@/services/api';
import { useAuth } from '@/context/AuthContext';

export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();
  const { user, updateUser } = useAuth();

  const changeLanguage = async (lng: string) => {
    try {
      // Змінюємо мову в i18n
      i18n.changeLanguage(lng);
      localStorage.setItem('language', lng);
      
      // Якщо користувач авторизований, зберігаємо мову в API
      if (user) {
        try {
          const updatedUser = await apiService.updateLanguage(lng);
          updateUser({ language: updatedUser.language });
        } catch (error) {
          console.error('Failed to update language in API:', error);
          // Продовжуємо роботу навіть якщо API запит не вдався
        }
      }
    } catch (error) {
      console.error('Failed to change language:', error);
    }
  };

  const getCurrentLanguage = () => {
    return i18n.language;
  };

  const getAvailableLanguages = () => {
    return [
      { code: 'ru', name: 'Русский' },
      { code: 'en', name: 'English' },
      { code: 'pl', name: 'Polski' },
      { code: 'de', name: 'Deutsch' },
      { code: 'uk', name: 'Українська' },
    ];
  };

  return {
    t,
    changeLanguage,
    getCurrentLanguage,
    getAvailableLanguages,
    isRTL: false,
  };
};
